import { isBefore } from '@e3dc-react/shell/Libs/date'
import { useUserRoles } from 'src/Hooks/user'
import { useAccountLinkContext } from 'src/Libs/installation-rights-management/provider/AccountLinksContext'
import useActiveInstallationContext from 'src/Libs/installations/hooks/use-active-installation-context'
import { isFlowTheme } from 'src/Libs/utils'
import { useTypedSelector } from 'src/State/RootReducer'
import { getUserAccountLink } from '../utils/get-user-account-link'

/**
 * A hook to determine the minimum "from" date for the system chart
 */
const useSystemChartMinFromDate = (): string | undefined => {
  const { isUser } = useUserRoles()
  const userId = useTypedSelector(s => s.auth.userId)
  const ssoId = useTypedSelector(s => s.user.userData?.ssoId)
  const { accountLinks } = useAccountLinkContext()
  const { storageDeviceLink } = useActiveInstallationContext()
  // Because the accountIDs from flow dont match with the userId, the users 'ssoId' needs to be used here
  const themedUserId = isFlowTheme ? ssoId : userId

  const storageFirstOnline = storageDeviceLink?.startAt
  const userAccountLink = getUserAccountLink(accountLinks, themedUserId)
  if (!isUser) return storageFirstOnline // * for higher user levels, we want to always show the full period of the device rather than the user specific ownership period
  if (!userAccountLink || !storageFirstOnline) return undefined

  const posessionStart = userAccountLink.startAt

  const earliestDate = isBefore(new Date(storageFirstOnline), new Date(posessionStart)) ? storageFirstOnline : posessionStart
  return earliestDate
}

export default useSystemChartMinFromDate
